import _ from 'lodash';

import { COMMON_DATE_FORMAT } from 'constants/date';

import { formatDate as formatDateUtil } from './date';
import { formatNumberToCurrencyString } from './number';

export const formatCurrencyValue = value =>
  _.isNil(value) ? null : formatNumberToCurrencyString(value);

export const formatDateValue = value => {
  if (_.isNil(value)) {
    return null;
  }

  return formatDateUtil(value, COMMON_DATE_FORMAT);
};

export const formatBooleanValue = value => {
  if (_.isNil(value)) {
    return null;
  }

  return value ? 'Yes' : 'No';
};

export const formatPercentValue = value => (_.isNil(value) ? null : `${value}%`);

export const formatArrayValue = value => {
  if (_.isNil(value)) {
    return null;
  }

  if (!Array.isArray(value)) {
    return String(value);
  }

  return value.join(', ');
};
